import React from "react";
import { useWizard } from "react-use-wizard";
import AnimatedTextInput from "../../components/animatedTextInput";
import { useTranslation } from "react-i18next";
import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const TextInputStep = ({ question, field, initState, onSubmitHandler }) => {
  const [value, setValue] = React.useState(initState || "");
  const history = useHistory();

  const { t } = useTranslation();

  const { previousStep, nextStep } = useWizard();
  const handleSubmit = () => {
    onSubmitHandler({
      [field]: {
        _state: value,
      },
    });
    nextStep();
  };
  const inputMissing = () => !value;

  const handleBack = () => {
    previousStep();
  };

  return (
    <div className="step-container">
      <NavigateBackWizardStep
        clickHandler={handleBack}
        title={t("title")}
        hideLibrary={true}
      />
      <>
        <div className="body_content py-5">
          <div className="inner_body ">
            <div className="fill_form light_fill_form">
              <h3 className="headtitle mb-4 text-break">{question}</h3>
              <AnimatedTextInput
                value={value}
                onChange={(e) => setValue(e.target.value)}
                id="height"
                isFocused={true}
              />

              <div className="btn_block d-flex justify-content-center bottom_button">
                <button
                  className="btn btn_primary"
                  disabled={inputMissing()}
                  onClick={() => handleSubmit()}
                >
                  {t("login.DOBSTEP.button")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default TextInputStep;
